import React from "react";
import "../../../assets/css/user/testimonials/Testimonials.css";


const testimonials = [
  {
    id: 1,
    text: '"Found an amazing dental deal at 60% off! The process was so smooth and the service was excellent."',
    name: "Ahmed Khan",
    role: "Customer",
    initial: "A",
    stars: 5,
  },
  {
    id: 2,
    text: '"I used to lose money on empty appointment slots. Now I list them as instant deals and they sell within minutes!"',
    name: "Sara Ali",
    role: "Seller",
    initial: "S",
    stars: 5,
  },
  {
    id: 3,
    text: '"Time4Pulse is my go-to app for finding discounted services. The instant deals are always amazing!"',
    name: "Usman Tariq",
    role: "Customer",
    initial: "U",
    stars: 4,
  },
];

const QuoteIcon = () => (
  <svg
    className="quote-icon"
    viewBox="0 0 40 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 30V18C0 13.6 1.26667 9.86667 3.8 6.8C6.33333 3.73333 9.93333 1.6 14.6 0.399994L16.4 3.6C14 4.4 12 5.73333 10.4 7.6C8.8 9.46667 8 11.5333 8 13.8H16V30H0ZM24 30V18C24 13.6 25.2667 9.86667 27.8 6.8C30.3333 3.73333 33.9333 1.6 38.6 0.399994L40 3.6C37.6 4.4 35.6 5.73333 34 7.6C32.4 9.46667 31.6 11.5333 31.6 13.8H40V30H24Z"
      fill="#f5c49a"
    />
  </svg>
);

const StarRating = ({ count }) => (
  <div className="star-rating">
    {[1, 2, 3, 4, 5].map((star) => (
      <span key={star} className={star <= count ? "star filled" : "star empty"}>
        ★
      </span>
    ))}
  </div>
);

const TestimonialCard = ({ testimonial }) => (
  <div className="testimonial-card">
    <div className="testimonial-card__top">
      <QuoteIcon />
      <p className="testimonial-card__text">{testimonial.text}</p>
    </div>
    <div className="testimonial-card__divider" />
    <div className="testimonial-card__footer">
      <div className="testimonial-card__author">
        <div className="author-avatar">{testimonial.initial}</div>
        <div className="author-info">
          <span className="author-name">{testimonial.name}</span>
          <span className="author-role">{testimonial.role}</span>
        </div>
      </div>
      <StarRating count={testimonial.stars} />
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="testimonials-section__header">
        <h2 className="testimonials-section__title">What People Say</h2>
        <p className="testimonials-section__subtitle">
          Trusted by thousands across Pakistan
        </p>
      </div>
      <div className="testimonials-grid">
        {testimonials.map((t) => (
          <TestimonialCard key={t.id} testimonial={t} />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;